module.exports = __webpack_public_path__ + "static/media/create-white.23f73407.svg";